export const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    p: { xs: 2, md: 2.5 },
};

export const topRow = {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 1.5,
};

export const pillsRow = {
    mt: 2,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    alignItems: 'center',
};

export const clearButton = {
    fontSize: '0.75rem',
    color: 'var(--ecal-lightblue)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    ml: 0.5,
    alignSelf: 'center',
    '&:hover': { textDecoration: 'underline' },
};

export const resultsCount = {
    mt: 2,
    fontSize: '0.72rem',
    color: 'var(--ecal-lightgrey)',
};

export const resultsHighlight = {
    color: 'var(--ecal-white)',
    fontWeight: 600,
};
